export const comments_4504527 = {"data":{"data":[],"links":{}}}